import { render, staticRenderFns } from "./FlowDiagram.vue?vue&type=template&id=2f3b52d9&scoped=true"
import script from "./FlowDiagram.vue?vue&type=script&lang=js"
export * from "./FlowDiagram.vue?vue&type=script&lang=js"
import style0 from "./FlowDiagram.vue?vue&type=style&index=0&id=2f3b52d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b52d9",
  null
  
)

export default component.exports